import React from "react";
import { Table, Tag, Empty } from "antd";
import dayjs from "dayjs";
import { RawMaterial, RawMaterialStock } from "../../../Types";

const stockColumns = [
  {
    title: "Batch Number",
    dataIndex: "batch_no",
    key: "batch_no",
    render: (v: string, rec: RawMaterialStock) => (
      <span className="font-medium text-gray-800 text-xs">
        {v}{" "}
        {rec.is_default === 1 && (
          <Tag color="blue" className="ml-1 text-[10px]">
            Default
          </Tag>
        )}
      </span>
    ),
  },
  {
    title: "Unit Cost",
    dataIndex: "cost_price",
    key: "cost_price",
    render: (v: number) => (
      <span className="text-red-500 font-bold text-xs">Rs. {v.toFixed(2)}</span>
    ),
  },
  {
    title: "Current Stock",
    dataIndex: "quantity",
    key: "quantity",
    render: (v: number) => (
      <Tag color={v > 0 ? "green" : "red"} className="font-bold text-xs">
        {v}
      </Tag>
    ),
  },
  {
    title: "Expiry Date",
    dataIndex: "expiry_date",
    key: "expiry_date",
    render: (v: string | null) => (
      <span className="text-xs text-gray-500">
        {v ? dayjs(v).format("YYYY-MM-DD") : "No Expiry"}
      </span>
    ),
  },
];

interface Props {
  record: RawMaterial;
}

export const StockBatchesTable: React.FC<Props> = ({ record }) => (
  <div className="px-4 py-3 bg-gray-50 rounded-md border border-gray-100 my-1">
    <h4 className="text-[11px] font-semibold text-gray-400 mb-2 uppercase tracking-wider">
      Stock Batches
    </h4>
    <Table
      dataSource={record.stocks || []}
      columns={stockColumns}
      pagination={false}
      size="small"
      rowKey="id"
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No batches found."
          />
        ),
      }}
    />
  </div>
);
